export default "__VITE_ASSET__hkNV454f__"